import { combineReducers } from "redux";
import { localeReducer } from "react-localize-redux";
import profileReducer from "./profileReducer";
import appSettingReducer from "./appSettingReducer";
import authReducer from "./authReducer";
import navigationReducer from "./navigationReducer";
import loadingReducer from "./loadingReducer";
import errorReducer from "./errorReducer";
import jobReducer from "./jobReducer";
import testsReducer from "./testsReducer";
import resultReducer from "./resultReducer";
import passwordresetReducer from "./passwordresetReducer";
import userReducer from "./userReducer";
import customerReducer from "./customerReducer";
import blobReducer from "./blobReducer";
import settingReducer from "./settingReducer";
import deviceReducer from "./deviceReducer";
import reportReducer from "./reportReducer";
import resetReducer from "./resetReducer";
import languageReducer from "./languageReducer";
import subtestReducer from "./subtestReducer";
import treeviewReducer from "./treeviewReducer";
import deviceRepositoryReducer from "./deviceRepositoryReducer";
import deviceSoftwareReducer from "./deviceSoftwareReducer";
import mfaReducer from "./mfaReducer";
import jobViewByReducer from "./jobViewByReducer";
import subscriptionReducer from "./subscriptionReducer";
import checkoutReducer from "./checkoutReducer";
import dashboardReducer from "./dashboardReducer";
import organisationReducer from "./organisationReducer";
import termsAcceptanceLogsReducer from "./termsAcceptanceLogsReducer";
import organisationDetailReducer from "./organisationDetailReducer";
import homeReducer from "./homeReducer";
import archiveReducer from "./archiveReducer";
import smartFlagReducer from "./smartFlagReducer";
import smartFlagProfileReducer from "./smartFlagProfileReducer";
import metricsReducer from "./metricsReducer";
import subscriptionManagementReducer from "./subscriptionManagementReducer";
import organisationPreferencesReducer from "./organisationPreferencesReducer";

const appReducer = combineReducers({
  localeReducer,
  profileReducer,
  appSettingReducer,
  authReducer,
  navigationReducer,
  loadingReducer,
  errorReducer,
  jobReducer,
  jobViewByReducer,
  testsReducer,
  resultReducer,
  passwordresetReducer,
  userReducer,
  customerReducer,
  blobReducer,
  settingReducer,
  deviceReducer,
  reportReducer,
  resetReducer,
  languageReducer,
  subtestReducer,
  treeviewReducer,
  deviceRepositoryReducer,
  deviceSoftwareReducer,
  mfaReducer,
  subscriptionReducer,
  checkoutReducer,
  dashboardReducer,
  organisationReducer,
  termsAcceptanceLogsReducer,
  organisationDetail: organisationDetailReducer,
  homeReducer,
  archiveReducer,
  smartFlagReducer,
  subscriptionManagementReducer,
  organisationPreferencesReducer,
  smartFlagProfileReducer,
  metricsReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    // Preserve locale state to prevent translate crash during logout redirect
    const { localeReducer } = state;
    state = { localeReducer };
  }

  return appReducer(state, action);
};

export default rootReducer;
